<script setup lang="ts">
import type { Organization } from '~/models/Organization'
import { useI18n } from 'vue-i18n'
import { computed, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { faPortalExit } from '@fortawesome/duotone-regular-svg-icons'
import { useAuthStore } from '~/stores/auth'
import { PendoFeature } from '~/models/Pendo'
import useOidc from '~/composables/useOidc'
import Button from '~/components/ui/Button.vue'

const { t } = useI18n()
const authStore = useAuthStore()
const { user, userOrganization, userOrganizations, isTeacher } = storeToRefs(authStore)
const selectedOrganization = ref<Organization | undefined>(undefined)
const { logoutRedirect } = useOidc()

const roleAtOrganization = computed(() => {
  return t('settings.roleAtOrganization', { role: isTeacher.value ? t('settings.roleTeacher') : t('settings.roleStudent'), organization: selectedOrganization.value?.name })
})

onMounted(() => {
  selectedOrganization.value = userOrganizations.value
    .find(({ number }) => number === userOrganization.value?.number)
})
</script>

<template>
  <div class="flex flex-col gap-2 py-2">
    <div class="flex items-center justify-between">
      <div class="mr-4">
        <p
          class="text-xl font-medium"
          v-text="user?.fullName"
        />
        <p
          v-if="selectedOrganization"
          class="text-base"
          v-text="roleAtOrganization"
        />
      </div>
      <Button
        :data-pendo="PendoFeature.Settings.Logout"
        @click="logoutRedirect"
      >
        <font-awesome-icon :icon="faPortalExit" />
        {{ t('logout') }}
      </Button>
    </div>
  </div>
</template>
